export default __webpack_public_path__ + "static/media/item_4.950a798d.webp";